import { useMutation, useQueryClient } from "react-query";

import {
  Syllabus,
  Move,
  StudentProgressStatus,
  StudentProgress,
} from "../../types";
import SyllabusService from "../../services/Syllabus";

import { makeQueryKey } from "./useFetchSyllabusStudentProgress";

function useUpdateSyllabusStudentProgress(
  onSuccess?: (progress: StudentProgress) => void
) {
  const queryClient = useQueryClient();

  return useMutation(
    ({
      syllabusId,
      moveId,
      status,
    }: {
      syllabusId: Syllabus["id"];
      moveId: Move["id"];
      status: StudentProgressStatus;
    }) =>
      SyllabusService.updateSyllabusStudentProgress(syllabusId, moveId, status),
    {
      onSuccess: (progress, { syllabusId, moveId }) => {
        queryClient.setQueryData(makeQueryKey(syllabusId, moveId), progress);

        onSuccess?.(progress);
      },
    }
  );
}

export default useUpdateSyllabusStudentProgress;
